import { render, staticRenderFns } from "./myOrder_view.vue?vue&type=template&id=38005a3d&scoped=true&"
import script from "./myOrder_view.vue?vue&type=script&lang=js&"
export * from "./myOrder_view.vue?vue&type=script&lang=js&"
import style0 from "./myOrder_view.vue?vue&type=style&index=0&id=38005a3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38005a3d",
  null
  
)

export default component.exports